module.exports = __webpack_public_path__ + "media/images/realizacje/real20-a9e90665944ceb6ae40ce61524506e4a.png";